"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _fetchActivityPage = require("./fetchActivityPage");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'activity-loader';
exports.cssAnchorName = cssAnchorName;
var PAGE_SIZE = 10;

var ActivityLoader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ActivityLoader, _Component);

  var _super = _createSuper(ActivityLoader);

  function ActivityLoader() {
    var _this;

    (0, _classCallCheck2.default)(this, ActivityLoader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      payloadHtml: '',
      page: 1,
      isLoading: true,
      hasMore: true,
      totalCount: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadPage", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(page) {
        var _yield$fetchActivityP, totalCount, payload, pagesTotal;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  isLoading: true
                });

                _context.prev = 1;
                _context.next = 4;
                return (0, _fetchActivityPage.fetchActivityPage)(_this.props.userId, page);

              case 4:
                _yield$fetchActivityP = _context.sent;
                totalCount = _yield$fetchActivityP.totalCount;
                payload = _yield$fetchActivityP.payload;

                if (totalCount) {
                  _context.next = 10;
                  break;
                }

                _this.setState({
                  isLoading: false,
                  hasMore: false,
                  totalCount: 0
                });

                return _context.abrupt("return");

              case 10:
                pagesTotal = Math.ceil((totalCount - 1) / PAGE_SIZE);

                _this.setState(function (prev) {
                  return {
                    payloadHtml: payload ? prev.payloadHtml + payload : prev.payloadHtml,
                    page: page + 1,
                    isLoading: false,
                    hasMore: page + 1 <= pagesTotal,
                    totalCount: totalCount
                  };
                });

                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);

                _this.setState({
                  isLoading: false
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 14]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLoadMore", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (_this.state.isLoading || !_this.state.hasMore) return;
      void _this.loadPage(_this.state.page);
    });
    return _this;
  }

  (0, _createClass2.default)(ActivityLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      void this.loadPage(1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userId = _this$props.userId,
          username = _this$props.username;
      var _this$state = this.state,
          payloadHtml = _this$state.payloadHtml,
          isLoading = _this$state.isLoading,
          hasMore = _this$state.hasMore,
          totalCount = _this$state.totalCount;
      var isEmpty = totalCount === 0;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        class: "table table--pad-l activities-list",
        dangerouslySetInnerHTML: {
          __html: payloadHtml
        }
      }), hasMore && !isEmpty && (0, _preact.h)("div", {
        class: "content--centered load-more-container"
      }, (0, _preact.h)("a", {
        rel: "nofollow",
        href: (0, _absoluteUrlRuntime.resolveUrl)((0, _fetchActivityPage.buildActivityUrl)(userId)),
        class: (0, _classnames.default)('btn--cta', 'btn--full-width', 'btn--load-more', {
          'is-loading': isLoading
        }),
        onClick: this.handleLoadMore
      }, (0, _preact.h)(_phrase.default, {
        p: "Show more",
        renderAsText: true
      }), (0, _preact.h)("span", {
        class: "loader"
      }))), isEmpty && (0, _preact.h)("div", {
        class: "box box__pad box__unmar"
      }, (0, _preact.h)("div", {
        class: "box box__pad--s box__unmar box--note"
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "member.profile.no.activity",
        count: {
          username: username
        },
        renderAsText: true
      }))));
    }
  }]);
  return ActivityLoader;
}(_preact.Component);

exports.default = ActivityLoader;